// Central list of SEO service pages. Names are kept as English keyword terms.
import {
  BrainCircuit,
  Smartphone,
  Workflow,
  Lightbulb,
  Code2,
  Users,
  Boxes
} from 'lucide-react';

export const SERVICES = [
  {
    slug: 'ai-saas-development',
    name: 'AI SaaS Development',
    tagline: 'Scalable AI-powered SaaS platforms, from MVP to enterprise.',
    icon: BrainCircuit
  },
  {
    slug: 'mobile-app-development',
    name: 'Mobile App Development',
    tagline: 'High-performance iOS & Android apps your users love.',
    icon: Smartphone
  },
  {
    slug: 'business-automation',
    name: 'Business Automation',
    tagline: 'Custom workflows and AI that eliminate repetitive work.',
    icon: Workflow
  },
  {
    slug: 'ai-consulting',
    name: 'AI Consulting',
    tagline: 'Turn AI from hype into measurable business advantage.',
    icon: Lightbulb
  },
  {
    slug: 'custom-web-development',
    name: 'Custom Web Development',
    tagline: 'Fast, SEO-ready websites and scalable web apps.',
    icon: Code2
  },
  {
    slug: 'crm-development',
    name: 'CRM Development',
    tagline: 'Custom CRM built around your real sales process.',
    icon: Users
  },
  {
    slug: 'erp-development',
    name: 'ERP Development',
    tagline: 'Unify operations with a tailored, scalable ERP system.',
    icon: Boxes
  }
];

export const getServiceMeta = (slug) => SERVICES.find((s) => s.slug === slug);
